import Model from './model.js'

export default {
  ReadAsMaster: function(params) {
    console.log("QRCODE PAGE: Read master asset has been depracted")
    if(params.action === 'ASSET'){
      params.data.query = 'Asset/Master/';
    }else if(params.action === 'CONTRACTOR'){
      params.data.query = 'Master/Contractor/';
    }else if(params.action === 'CITY'){
      params.data.query = 'Master/City-In-CoverageMaster/';
    }else if(params.action === 'CURRENCY'){
      params.data.query = 'Master/Currencies/';
    }else {
      params.data.query = 'Maintenance/Service/Master/';
    }
    Model.ReadAsMaster(params);
  },
  Update: function(params){
    Model.Update(params);
  }
}


// WEBPACK FOOTER //
// ./src/App/qrreader/presenter.js